type UserPayload = {
	scope: string;
	email: string;
	photourl: string;
	tags: string[];
	options: string[];
	language: string;
	fullname: string;
    firstname: string;
    lastname: string;
	display: string;
	exp: number;
	iat: number;
	nbf: number;
    playerid: number;
	username: string;
	accounts: number[];
    autolists: string[];
    systemlists: number[];
    label_staff: boolean;
    verified: boolean;
};

const useToken = () => {
	const base64Decode = (token: string) => {
		let result = '';
		if (token) {
			let tokenSanitized = token.replace(/-/g, '+').replace(/_/g, '/');
			switch (tokenSanitized.length % 4) {
				case 0:
					break;
				case 2:
					tokenSanitized += '==';
					break;
				case 3:
					tokenSanitized += '=';
					break;
				default:
					tokenSanitized = '';
			}
			if (tokenSanitized !== '')
				result = decodeURIComponent(escape(window.atob(tokenSanitized)));
		}
		return result;
	};

	const getPayload = (token: string): UserPayload | null => {
		try {
			let payload = null;
			if (token) {
				const segments = token.split('.');
				if (segments.length === 3) {
					payload = JSON.parse(base64Decode(segments[1]) || null);
				}
			}
			return payload;
		} catch (_error) {
			return null;
		}
	};


	const getUser = (): UserPayload | null => {
		const tokenItem = localStorage.getItem('accessToken');
		if (!tokenItem) return null;
		return getPayload(tokenItem);
	};

	return {
		getPayload,
		getUser,
	};
};

export default useToken;
